import * as types from '../constants';

export const setHeaderItem = headerItem => ({
  type: types.SET_HEADER_ITEM,
  payload: headerItem,
});
